import React from 'react';
import styles from './WorkoutCard.module.css';
import PostOptionIcon from '../svgs/PostOptionIcon';
import ReactDOM from 'react-dom';
import moment from 'moment';

class WorkoutCard extends React.Component {
  constructor(props) {
    super(props);
    this.contextMenuContainerRef = React.createRef();
    this.state = {
      openDialog: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, true);
  }

  handleClickOutside = (event) => {
    if (
      this.contextMenuContainerRef.current &&
      !this.contextMenuContainerRef.current.contains(event.target)
    ) {
      this.props.setOptionsOverlayVisible(false);
    }
  };

  render() {
    const {
      miles,
      steps,
      hours,
      minutes,
      seconds,
      onDelete,
      onShare,
      canShareWorkout,
      optionsOverlayVisible,
      toggleOverlay,
      workoutDate,
      ounces_of_water,
      workoutDateTime,
    } = this.props;

    const workoutCardDisplay = () => {
      return (
        <>
          <div>
            <h1 className={styles.workoutInfoText}>
              {parseFloat(miles)
                .toString()
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
            </h1>
            <span className={styles.workoutInfoLabelText}>MILES</span>
          </div>
          <div>
            <h1 className={styles.workoutInfoText}>
              {parseInt(steps)
                .toString()
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
            </h1>
            <span className={styles.workoutInfoLabelText}>STEPS</span>
          </div>
          <div>
            <h1 className={styles.workoutInfoText}>
              {`${hours}:${minutes}:${seconds}`}
            </h1>
            <span className={styles.workoutInfoLabelText}>DURATION</span>
          </div>
        </>
      );
    };

    const hydrationCardDisplay = () => {
      return (
        <>
          <div>
            <h2>Hydration</h2>
            <p>{moment(workoutDateTime).format('MMM DD, YYYY - HH:mm A')}</p>
          </div>
          <div>
            <h1 className={styles.workoutInfoText}>{ounces_of_water}</h1>
            <p style={{textAlign: 'right'}}>oz</p>
          </div>
        </>
      );
    };

    return (
      <div className={styles.workoutCardContainer}>
        <div
          className={[styles.dateBox]}
          style={{justifyContent: ounces_of_water && 'end'}}>
          {!ounces_of_water && (
            <p className={[styles.workoutDatetext]}>{workoutDate}</p>
          )}
          <div className={styles.optionsContainer}>
            <div
              className={styles.optionsIconWrapper}
              onClick={() => toggleOverlay()}>
              <PostOptionIcon height="24" width="24" />
            </div>
            {optionsOverlayVisible && (
              <div
                ref={this.contextMenuContainerRef}
                className={styles.overlayContainer}>
                {!ounces_of_water && canShareWorkout && (
                  <button onClick={() => onShare()}>Share</button>
                )}
                <button onClick={() => onDelete()}>Delete</button>
              </div>
            )}
          </div>
        </div>
        <div className={styles.workoutInfoContainer}>
          {ounces_of_water ? hydrationCardDisplay() : workoutCardDisplay()}
        </div>
      </div>
    );
  }
}

export default WorkoutCard;
